var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase } from "./reactquestion_element";
import { SurveyPanelBase } from "./panel-base";
import { TitleElement } from "./components/title/title-element";
import { SurveyElementErrors } from "./reactquestion";
import { ReactElementFactory } from "./element-factory";
var SurveyPage = /** @class */ (function (_super) {
    __extends(SurveyPage, _super);
    function SurveyPage(props) {
        return _super.call(this, props) || this;
    }
    SurveyPage.prototype.getPanelBase = function () {
        return this.props.page;
    };
    Object.defineProperty(SurveyPage.prototype, "page", {
        get: function () {
            return this.panelBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyPage.prototype.renderElement = function () {
        var title = this.renderTitle();
        var description = this.renderDescription();
        var rows = this.renderRows(this.panelBase.cssClasses);
        var errors = (React.createElement(SurveyElementErrors, { element: this.panelBase, cssClasses: this.panelBase.cssClasses, creator: this.creator }));
        return (React.createElement("div", { ref: this.rootRef, className: this.page.cssRoot },
            title,
            description,
            errors,
            rows));
    };
    SurveyPage.prototype.renderTitle = function () {
        return React.createElement(TitleElement, { element: this.page });
    };
    SurveyPage.prototype.renderDescription = function () {
        if (!this.page._showDescription)
            return null;
        var text = SurveyElementBase.renderLocString(this.page.locDescription);
        return (React.createElement("div", { className: this.panelBase.cssClasses.page.description }, text));
    };
    return SurveyPage;
}(SurveyPanelBase));
export { SurveyPage };
ReactElementFactory.Instance.registerElement("sv-page", function (props) {
    return React.createElement(SurveyPage, props);
});
